import Quill from "quill";
import Delta from "quill-delta";

const Clipboard = Quill.import('modules/clipboard') as typeof Clipboard;

/**
 * Prevent pasting HTML in the rich text area
 */
export class PlainTextClipboard extends Clipboard {

    private REGEXP_GLOBAL = /https?:\/\/[^\s]+/g;

    onPaste(range, { text }) {

        // Format paste URLs to links
        const matches = text.match(this.REGEXP_GLOBAL);
        if (matches && matches.length > 0) {
            const match = matches[0];
            const delta = this.quill.insertText(range.index, match, 'link', match, Quill.sources.USER);
            this.quill.setSelection(
                delta.length() - range.length,
                Quill.sources.SILENT,
            );
        } else {

            // paste plain text
            const delta = new Delta()
                .retain(range.index)
                .delete(range.length)
                .insert(text);
            this.quill.updateContents(delta, Quill.sources.USER);
            this.quill.setSelection(
                delta.length() - range.length,
                Quill.sources.SILENT,
            );
        }

        this.quill.scrollSelectionIntoView();
    }

}